import React from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./header.css";

export const Header1 = () => {
  return (
    <Navbar className="custom-navbar2" variant="dark" expand="lg">
      <Navbar.Toggle aria-controls="basic-navbar-nav2"/>
      <Navbar.Collapse id="basic-navbar-nav2" style={{backgroundColor:"#6a9aa0"}}>
        <Nav className="mr-auto header-option-box">
          <NavLink to="/" className="nav-link-text">HOME</NavLink>

          <NavDropdown title="COMMITTEES">
            <NavDropdown.Item as={Link} to="/committees/organizing">ORGANIZING COMMITTEE</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/committees/steer ing">STEERING COMMITTEE</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/committees/supporting">SUPPORTING COMMITTEE</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/committees/technical">TECHNICAL COMMITTEE</NavDropdown.Item>
          </NavDropdown>

          <NavDropdown title="SUBMISSION">
            <NavDropdown.Item as={Link} to="/submission/call for papers">CALL FOR PAPERS</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/submission/call for sponsors">CALL FOR SPONSORS</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/submission/call for speakers">CALL FOR SPEAKERS</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/submission/call for workshop">CALL FOR WORKSHOP</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/submission/call for tutorial">CALL FOR TUTORIAL</NavDropdown.Item>
          </NavDropdown>

          <NavDropdown title="PROGRAM">
            {/* <NavDropdown.Item as={Link} to="/program/program">PROGRAM</NavDropdown.Item> */}
            <NavDropdown.Item as={Link} to="/program/important-dates">IMPORTANT DATES</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/program/plenary and keynote speakers">PLENARY & KEYNOTE SPEAKERS</NavDropdown.Item>
            {/* <NavDropdown.Item as={Link} to="/program/invited speakers">INVITED SPEAKERS</NavDropdown.Item> */}
            {/* <NavDropdown.Item as={Link} to="/program/special sessions">SPECIAL SESSIONS</NavDropdown.Item> */}
            {/* <NavDropdown.Item as={Link} to="/program/workshop">WORKSHOP</NavDropdown.Item> */}
            {/* <NavDropdown.Item as={Link} to="/program/tutorial">TUTORIAL</NavDropdown.Item> */}
            {/* <NavDropdown.Item as={Link} to="/program/graduate forum">GRADUATE FORUM</NavDropdown.Item> */}
            {/* <NavDropdown.Item as={Link} to="/program/topical speakers">TOPICAL SPEAKERS</NavDropdown.Item> */}
          </NavDropdown>

          <NavDropdown title="REGISTRATION">
            <NavDropdown.Item as={Link} to="/registration/visa">VISA LETTER REQUEST</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/registration/awards">AWARDS</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/registration/ihci travel grant">IHCI TRAVER GRANT</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/registration/payment and fees">PAYMENT & FEES</NavDropdown.Item>
          </NavDropdown>

          <NavLink to="http://eng.daegucvb.com/mice/infra/traffic/" className="nav-link-text">TRANSPOTATION</NavLink>
          <NavLink to="/ihci-2023" className="nav-link-text">IHCI SOCIETY</NavLink>
          <NavLink to="https://www.ihcisociety.org/prior-ihci" className="nav-link-text">PRIOR IHCI</NavLink>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};